import React, { useEffect, useState, useRef } from 'react';

import data from './data';
import Heading from '../../../components/Heading';
import RadioButtons from '../../../components/RadioButtons.tsx';
import { Title, Subtitle, Description } from '../styled';
import useAnimation from './useAnimation';

const Content = ({ index, setIndex }: {
  index: number,
  setIndex: (n: number) => void
}) => {
  const title = useRef<HTMLHeadingElement>(null);
  const subtitle = useRef<HTMLHeadingElement>(null);
  const description = useRef<HTMLParagraphElement>(null);

  const [localIndex, setLocalIndex] = useState(index);

  const [fadeout, fadein] = useAnimation([title, description, subtitle]);

  useEffect(() => {
    fadeout.current?.play(0).eventCallback("onComplete", () => {
      setLocalIndex(index);
      fadein.current?.play(0);
    });
  }, [index]);

  const handleRadioClick = (i: number) => {
    if (
      fadeout.current && !fadeout.current.isActive() &&
      fadein.current && !fadein.current.isActive()
    ) {
      setIndex(i);
    }
  }

  return (
    <>
      <Heading number="01" label="Our History" align="left" />

      <Title ref={title}>{data[localIndex].title}</Title>
      <Subtitle ref={subtitle}>{data[localIndex].subtitle}</Subtitle>
      <Description ref={description}>{data[localIndex].description}</Description>

      <RadioButtons
        amount={data.length}
        currentActive={index}
        onRadioClick={handleRadioClick}
      />
    </>
  );
}

export default Content;